import { render } from "./TabService.vue?vue&type=template&id=36dc6e2e&scoped=true"
import script from "./TabService.vue?vue&type=script&lang=js"
export * from "./TabService.vue?vue&type=script&lang=js"

import "./TabService.vue?vue&type=style&index=0&id=36dc6e2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36dc6e2e"]])

export default __exports__